import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from "rxjs";

import { GetInboxesByPollParserIdWIthPaginationQuery } from "src/app/core/api/models";
import { EventTypes } from "src/app/core/constants/event-types";
import { LoggerService } from "src/app/core/services/logger.service";
import { BaseFormModule } from "src/app/pages/shared/base/modules/base-form.module";
import { ModalTitleComponent } from "../../../../../shared/global/modal-title/modal-title.component";


@Component({
    selector: 'app-poll-parser-inboxes-modal',
    templateUrl: './poll-parser-inboxes-modal.component.html',
    styleUrls: ['./poll-parser-inboxes-modal.component.scss'],
    imports: [BaseFormModule, ModalTitleComponent]
})
export class PollParserInboxesModalComponent {
  //#region properties

  pollParserId: number;
  pollParserFormula: any[];
  model: GetInboxesByPollParserIdWIthPaginationQuery = {};
  title: string;
  isChecked: any[] = [];
  protected onDestroy$ = new Subject<void>();

  //#endregion

  constructor(
    private loggerService:LoggerService,
    private dialogRef: MatDialogRef<PollParserInboxesModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.pollParserId = data?.pollParserId;
    this.pollParserFormula = data?.pollParserFormula;
  }


  onClose() {
    this.dialogRef.close();
    this.unSubs();
  }


  unSubs() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  onConfirm() {
    this.dialogRef.close({ parserId: this.pollParserId, targetAnswer: this.model.targetAnswer });
  }


  changePollParserFormula(keyword, counter) {
    try {
      this.isChecked = []
      this.isChecked[counter] = true;
      this.model.targetAnswer = keyword;
    } catch (error) {
      this.loggerService.logError('poll-parser-inboxes-modal-component', error, EventTypes.services)

    }
  }

}
